import React from 'react';
import { MessageBarType, Separator, Stack } from '@fluentui/react';
import {
  useNavigate, useLocation, Routes, Route,
} from 'react-router-dom';
import Store from '../shared/state/Store';
import CloudUsageAllowances from '../admin-dashboard/CloudUsageAllowances';
import LicensesActivations from '../admin-dashboard/LicensesActivations';
import EndUsers from '../admin-dashboard/EndUsers';
import Menu, { DefaultNavOption } from '../admin-dashboard/Menu';
import StackTokens from '../shared/StackTokens';
import Theme from '../shared/Theme';
import Routing from '../shared/Routing';
import User from '../shared/User';
import MessageBar from '../shared/MessageBar';

export default () => {
  const [globalState] = Store.useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const routingTree = Routing.getTree(globalState).home.routes.administrationDashboard;

  React.useEffect(() => {
    if (location.pathname === routingTree.path) {
      // If no subcomponent selected, navigate to default subcomponent
      navigate(DefaultNavOption, { replace: true });
    }
  }, [location.pathname]);

  const featuresEnabled = User.getEnabledFeatures(globalState).includes('subscriptionAdministration');
  const isOwnSubscription = User.isOwnSubscription(globalState);
  if (!featuresEnabled) {
    return <MessageBar messageBarType={MessageBarType.error} text="This feature is not enabled for your account" />;
  }
  if (!isOwnSubscription) {
    return <MessageBar messageBarType={MessageBarType.error} text="You are not the subscription administrator for this account" />;
  }

  return (
    <Stack vertical>
      <header className={Theme.styles.menuHeader}>Administration Dashboard</header>

      <Stack horizontal tokens={StackTokens.spacing}>
        <Stack vertical>
          <Menu />
        </Stack>
        <Separator vertical />
        <Stack vertical grow>
          <Routes>
            <Route element={<CloudUsageAllowances />} path={routingTree.routes.cloudUsageAllowances.getRelativePath(routingTree.path)} />
            <Route element={<LicensesActivations />} path={routingTree.routes.licensesActivations.getRelativePath(routingTree.path)} />
            <Route element={<EndUsers />} path={routingTree.routes.endUsers.getRelativePath(routingTree.path)} />
          </Routes>
        </Stack>
      </Stack>
    </Stack>
  );
};
